"use client";

import type { PlayingState } from "@ui/hooks/useTtsGeneration";

import { Button } from "@components/core/Button";
import Spinner20 from "@ui/icons/20x20/spinner-20.svg";
import { useTranslations } from "next-intl";
import * as m from "motion/react-m";

interface PlayButtonProps {
  disabled?: boolean;
  onPlay: () => void;
  playingState: PlayingState;
  willRegenerate?: boolean;
}

export function PlayButton({ disabled, onPlay, playingState, willRegenerate }: PlayButtonProps) {
  const t = useTranslations("ClientKeys.Globals");
  const isLoading = playingState === "loading";
  const isPlaying = playingState === "playing";
  const isPaused = playingState === "paused";

  const getLabel = () => {
    if (isPlaying) return t("pause");
    if (isPaused && !willRegenerate) return t("resume");
    return t("play");
  };

  return (
    <Button disabled={disabled || isLoading} onClick={onPlay} size='lg' variant='primary'>
      <m.span animate={{ opacity: isLoading ? 1 : 0 }} className='tw-absolute' initial={{ opacity: 0 }}>
        <Spinner20 className='color-white' />
      </m.span>
      <m.span animate={{ opacity: isLoading ? 0 : 1 }}>{getLabel()}</m.span>
    </Button>
  );
}
